module.exports = __webpack_public_path__ + "img/ebane_nero.124f097e.jpg";